import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'CantAccsessToolTip',
  props: ["becauseAnonymous"],
  setup(__props) {

const props = __props;

const t = useI18n().t;



const reason = computed(() => {
  if (props.becauseAnonymous) {
    return t("becauseAnonymous");
  }
  return t("becauseNoAccess");
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_component_q_tooltip, {
    class: "bg-dark",
    anchor: "top middle"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(reason.value), 1)
    ]),
    _: 1
  }))
}
}

})